module.exports = __webpack_public_path__ + "img/arrow.2b134f33.webp";